import React from 'react';
import { message, Tag } from 'antd';

const CampaignBriefComponent = ({ brief, hashtags, keywords, mentions, guidelines, refLinks }) => {
  const copyLinkToClipboard = (link) =>{
    navigator.clipboard.writeText(link);
    message.success('Reference link copied to clipboard');
  };
  return (
    <div className="row campaign_details_base">
      <div className="col-md-12">
        <p>Task Description</p>
        <h6 className="para">{brief}</h6>
      </div>
      <div className="col-md-6">
        <p>Hashtags</p>
        <div>
          {
            hashtags.length &&
                        hashtags.map((hashtag, index)=>(
                          <Tag key={hashtag+index}>{hashtag}</Tag>
                        ))
          }
        </div>
      </div>
      <div className="col-md-6">
        <p>keywords</p>
        <div>
          {
            keywords.length &&
                        keywords.map((keyword, index)=>(
                          <Tag key={keyword+index}>{keyword}</Tag>
                        ))
          }
        </div>
      </div>
      <div className="col-md-6">
        <p>Mentions</p>
        <div>
          {
            mentions.length &&
                        mentions.map((mention, index)=>(
                          <Tag key={mention+index}>{mention}</Tag>
                        ))
          }
        </div>
      </div>
      <div className="col-md-12">
        <p>Task Guidelines</p>
        <h6 className="para">{guidelines}</h6>
      </div>
      <div className="col-md-12">
        <p>Reference Links</p>
        <div>
          {
            refLinks.length &&
                        refLinks.map((link, index)=>(
                          <Tag key={link+index}
                            onClick={() => copyLinkToClipboard(link)}>{link}</Tag>
                        ))
          }
        </div>
      </div>
    </div>
  );
};

export default CampaignBriefComponent;
